import ComboCombolist from "./combolist";
import isToggleActive from "./toggles/toggles.js";

window.o_combo_combolist = window.o_combo_combolist || [];

export function initCinema() {
	const containers = document.querySelectorAll(".combo_combolist-container");
	Array.from(containers).forEach(container => {
		if (container.getAttribute("data-tracked") !== "true") {
			container.setAttribute("data-tracked", "true");
			const combolist = new ComboCombolist(container);
			combolist.initCinemaEvents();
			isToggleActive("ENABLE_COMBO_MODAL")
				? combolist.addClickEventListenersForComboMoodImage()
				: combolist.oldAddClickEventListenersForComboMoodImage();
			combolist.addClickEventListenersForArticles();
			window.o_combo_combolist.push(combolist);
		}
	});
}
